module.exports = __webpack_public_path__ + "media/images/athletes/2191-8e165e9d012339c1717636900e9f6b97.png";